var Login = window.Login;
var Connect = window.Connect;
var hasProp = window.hasProp;
var extend = window.extend;
var handleMessage = window.handleMessage;
var handleMessage,
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Aedu.Auth.OauthButton = function (superClass) {
  var DEBOUNCE_PERIOD;
  extend(OauthButton, superClass);
  function OauthButton() {
    return OauthButton.__super__.constructor.apply(this, arguments);
  }
  DEBOUNCE_PERIOD = 2000;
  OauthButton.prototype.errorTemplate = 'auth/templates/oauth_error';
  OauthButton.prototype.events = {
    'click': 'handleClick'
  };
  OauthButton.prototype.initialize = function (options) {
    OauthButton.__super__.initialize.apply(this, arguments);
    this.adapter = new Aedu.Auth.OAuthAdapter(this.provider());
    this.debounceClickHandler();
    this.listenToOAuthEvents();
    return this.redirectPath = options.redirectPath, options;
  };
  OauthButton.prototype.debounceClickHandler = function () {
    return this.debouncedHandleClick = _.debounce(function (_this) {
      return function (e) {
        return _this.handleClick(e);
      };
    }(this), DEBOUNCE_PERIOD, true);
  };
  OauthButton.prototype.handleClick = function (e) {
    e.preventDefault();
    return this.attemptOAuthConnect();
  };
  OauthButton.prototype.attemptOAuthConnect = function () {};
  OauthButton.prototype.provider = function () {};
  OauthButton.prototype.listenToOAuthEvents = function () {};
  OauthButton.prototype.prettyProvider = function () {
    return $h.capitalize(this.provider());
  };
  OauthButton.prototype.displayError = function (error) {
    var el, ref;
    if ((ref = this.$errorModal) != null) {
      ref.remove();
    }
    el = JST[this.errorTemplate]({
      message: error
    });
    $('#bootstrap-modal-container').append(el);
    this.$errorModal = $('#oauth-error-modal');
    return this.$errorModal.modal('show');
  };
  OauthButton.prototype.redirectToLoginWithPrefilledEmail = function (email) {
    return window.parent.location.href = $a.build_url('/login', [["login", email], ["email_was_taken", true], ["provider", this.prettyProvider()]]);
  };
  return OauthButton;
}(Backbone.View);
Aedu.Auth.OauthButton.Login = function (superClass) {
  extend(Login, superClass);
  function Login() {
    return Login.__super__.constructor.apply(this, arguments);
  }
  Login.prototype.initialize = function (options) {
    Login.__super__.initialize.apply(this, arguments);
    return this.rememberMeCheckboxId = options.rememberMeCheckboxId;
  };
  Login.prototype.attemptOAuthConnect = function () {
    return this.adapter.login({
      remember_me: this.rememberMe()
    });
  };
  Login.prototype.listenToOAuthEvents = function () {
    this.listenTo(this.adapter, 'oauth:success', function () {
      if (window.parent !== window || window.location.href === this.successRedirectUrl()) {
        return window.parent.location.reload();
      } else {
        return window.location.href = this.successRedirectUrl();
      }
    });
    this.listenTo(this.adapter, 'oauth:email_taken', function (_this) {
      return function (data) {
        return _this.redirectToLoginWithPrefilledEmail(data.email);
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:invalid', function (_this) {
      return function () {
        return _this.displayError("We couldn't find an Academia.edu account matching your " + _this.prettyProvider() + " account.<br/><br/>Please choose a different login method or <a href='/signup'>create an account</a>.");
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:error', function (_this) {
      return function () {
        return _this.displayError("Sorry, something went wrong! We're looking into it now.<br/><br/>Please choose a different login method or try again in a few minutes.");
      };
    }(this));
    return this.listenTo(this.adapter, 'oauth:canceled', function (_this) {
      return function (error) {
        return _this.displayError(error.details);
      };
    }(this));
  };
  Login.prototype.successRedirectUrl = function () {
    if (this.redirectPath) {
      return this.redirectPath;
    } else if (window.parent !== window) {
      return window.parent.location.href;
    } else if (/\/(login|signup)/.test(document.location.pathname)) {
      return "/";
    } else {
      return document.location.href;
    }
  };
  Login.prototype.rememberMe = function () {
    var rememberMeElement;
    rememberMeElement = document.getElementById(this.rememberMeCheckboxId);
    if (rememberMeElement) {
      if (rememberMeElement.checked) {
        return '1';
      } else {
        return '0';
      }
    } else {
      return '1';
    }
  };
  return Login;
}(Aedu.Auth.OauthButton);
Aedu.Auth.OauthButton.Login.Facebook = function (superClass) {
  extend(Facebook, superClass);
  function Facebook() {
    return Facebook.__super__.constructor.apply(this, arguments);
  }
  Facebook.prototype.provider = function () {
    return 'facebook';
  };
  return Facebook;
}(Aedu.Auth.OauthButton.Login);
Aedu.Auth.OauthButton.Login.Google = function (superClass) {
  extend(Google, superClass);
  function Google() {
    return Google.__super__.constructor.apply(this, arguments);
  }
  Google.prototype.provider = function () {
    return 'google';
  };
  return Google;
}(Aedu.Auth.OauthButton.Login);
Aedu.Auth.OauthButton.Connect = function (superClass) {
  extend(Connect, superClass);
  function Connect() {
    return Connect.__super__.constructor.apply(this, arguments);
  }
  Connect.prototype.initialize = function (options) {
    this.extraRegParams = (options != null ? options.registrationParams : void 0) || {};
    this.downloadOnRedirect = (options != null ? options.download_on_redirect : void 0) || false;
    return Connect.__super__.initialize.apply(this, arguments);
  };
  Connect.prototype.attemptOAuthConnect = function () {
    return this.adapter.register(this.extraRegParams);
  };
  Connect.prototype.listenToOAuthEvents = function () {
    this.listenTo(this.adapter, 'oauth:success', function (data) {
      var redirectUrl;
      if (data != null ? data.redirect : void 0) {
        redirectUrl = data.redirect;
        if (this.downloadOnRedirect) {
          redirectUrl = redirectUrl.concat('?auto=download');
        }
        return window.parent.location.href = redirectUrl;
      } else {
        return window.parent.postMessage('oauth:success:reload', '*');
      }
    });
    this.listenTo(this.adapter, 'oauth:email_taken', function (_this) {
      return function (data) {
        return _this.redirectToLoginWithPrefilledEmail(data.email);
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:error oauth:invalid', function (_this) {
      return function (errors) {
        if (errors != null && Array.isArray(errors) && errors.some(function (error) {
          return error[0] === 'user[last_name]' || error[0] === 'user[first_name]';
        })) {
          return _this.displayError("Your " + _this.prettyProvider() + " account is missing a first or last name. Please add one to your " + _this.prettyProvider() + " account and try again, or use a different login method.");
        } else {
          return _this.displayError("Sorry, something went wrong! We're looking into it now.<br/><br/>Please choose a different signup method or try again in a few minutes. " + errors);
        }
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:canceled', function (_this) {
      return function (error) {
        return _this.displayError(error.details);
      };
    }(this));
    if (this.options.track) {
      return this.trackEvents();
    }
  };
  Connect.prototype.trackEvents = function () {
    this.listenTo(this.adapter, 'oauth:attempt', function (_this) {
      return function () {
        return _this.notify(_this.eventType());
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:success', function (_this) {
      return function () {
        return _this.notify(_this.eventType() + '_complete');
      };
    }(this));
    this.listenTo(this.adapter, 'oauth:email_taken', function (_this) {
      return function () {
        return _this.notify('email_was_taken');
      };
    }(this));
    return this.listenTo(this.adapter, 'oauth:canceled', function (_this) {
      return function () {
        return _this.notify(_this.eventType() + '_cancelled');
      };
    }(this));
  };
  Connect.prototype.notify = function (event) {
    this.notifier || (this.notifier = new c.Server.Notification('sutd'));
    return this.notifier.notify({
      event_type: event,
      auvid: $auvid,
      hit_id: window.Aedu && Aedu.hit_data && Aedu.hit_data.id || null
    });
  };
  Connect.prototype.eventType = function () {};
  return Connect;
}(Aedu.Auth.OauthButton);
Aedu.Auth.OauthButton.Connect.Facebook = function (superClass) {
  extend(Facebook, superClass);
  function Facebook() {
    return Facebook.__super__.constructor.apply(this, arguments);
  }
  Facebook.prototype.provider = function () {
    return 'facebook';
  };
  Facebook.prototype.eventType = function () {
    return 'fb_connect';
  };
  return Facebook;
}(Aedu.Auth.OauthButton.Connect);
Aedu.Auth.OauthButton.Connect.Google = function (superClass) {
  extend(Google, superClass);
  function Google() {
    return Google.__super__.constructor.apply(this, arguments);
  }
  Google.prototype.provider = function () {
    return 'google';
  };
  Google.prototype.eventType = function () {
    return 'google_connect';
  };
  return Google;
}(Aedu.Auth.OauthButton.Connect);
handleMessage = function (event) {
  if (event.origin === window.location.origin && event.data === 'oauth:success:reload') {
    return window.location.reload();
  }
};
window.addEventListener('message', handleMessage, false);
export var Connect = {
  Facebook: Aedu.Auth.OauthButton.Connect.Facebook,
  Google: Aedu.Auth.OauthButton.Connect.Google
};
export var Login = {
  Facebook: Aedu.Auth.OauthButton.Login.Facebook,
  Google: Aedu.Auth.OauthButton.Login.Google
};
window.handleMessage = handleMessage;
window.extend = extend;
window.hasProp = hasProp;
window.Connect = Connect;
window.Login = Login;